import {
  useSearchParamsObject,
  consolidateEmbeddedCategoryWithParams,
} from '../url';
import getEmbeddedCategoryId from '../embeddedScript/getEmbeddedCategoryId';
import useSupportedLanguage from '../data/language/useSupportedLanguage';

const useListingsV2Params = () => {
  const languageCode = useSupportedLanguage();
  const searchParamObject = useSearchParamsObject();
  const categoryId = getEmbeddedCategoryId();
  const consolidatedParams = {
    ...consolidateEmbeddedCategoryWithParams(categoryId, searchParamObject),
    vibeIds: [
      ...(Array.isArray(searchParamObject.vibeIds)
        ? searchParamObject.vibeIds
        : [searchParamObject.vibeIds]
      ).filter(Boolean),
    ],
    limit: Number(searchParamObject.limit) || 24,
    language: languageCode,
    isUnlisted: (searchParamObject.isUnlisted === 'true' ? 'true' : 'false') as
      | 'true'
      | 'false',
  };
  return consolidatedParams;
};

export default useListingsV2Params;
